// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2V3s0","row":"ProcedureTreatmentSummary_row__202bB"};